import { Prop } from "vue-property-decorator";
import { RequestsStates } from "../../data/enums/requestsStates";
import Vue from "vue";

export class OperationBlockVue extends Vue {
  @Prop() operDate!: string;

  @Prop() operPicture!: string;

  @Prop() operRequestState!: number;

  @Prop() operDesc!: string;

  @Prop() operSum!: number;

  @Prop() operCurrency!: string;

  @Prop() operCategory!: string;

  @Prop() operStatus!: number;

  @Prop() acceptedStates!: Array<RequestsStates>;

  get mainSum(): string {
    return this.$options.filters.sum(
              this.operSum ? this.operSum : 0,
              true,
              this.operCurrency ? this.operCurrency : ''
            ).toString().substr(0, this.$options.filters.sum(
              this.operSum ? this.operSum : 0,
              true,
              this.operCurrency ? this.operCurrency : ''
            ).toString().indexOf(',')+1)
  }

  getOperStateIconClass(status: number) {
    let st: string = "";
    switch (status) {
      case 1:
        st = "success-icon";
        break;
      case 3:
        st = "wait-icon";
        break;
      // case RequestsStates.ExecuteError:
      // case RequestsStates.Denied:
      //   st = "error-icon";
      //   break;
      default:
        break;
    }
    return st;
  }

  getOperReqStateIconClass(state: RequestsStates) {
    let st: string = "";
    let acceptedState: RequestsStates = 0;
    if (this.acceptedStates && this.acceptedStates.length)
      acceptedState = this.acceptedStates.find((aState: RequestsStates) => aState === state);
    if (acceptedState || !this.acceptedStates) {
      switch (state) {
        case RequestsStates.Executed:
          st = "success-icon";
          break;
        case RequestsStates.Executing:
          st = "wait-icon";
          break;
        case RequestsStates.ExecuteError:
        case RequestsStates.Denied:
          st = "error-icon";
          break;
        default:
          break;
      }
    }
    return st;
  }
}
